var map = {
	"./de.json": "../assets/i18n/messages/de.json",
	"./en.json": "../assets/i18n/messages/en.json",
	"./es.json": "../assets/i18n/messages/es.json",
	"./fr.json": "../assets/i18n/messages/fr.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../assets/i18n/messages sync recursive ^\\.\\/.*\\.json$";